// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-player-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 400px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.audio-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 15px 0;
}

.player-controls {
    display: flex;
    align-items: center;
    gap: 15px;
}

.play-pause-btn {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border: 2px solid #3700b3; /* Red color from image */
    border-radius: 50%;
    background-color: transparent;
    color: #3700b3;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0;
    /* Nudge the play icon to be visually centered */
    padding-left: 3px;
}

.play-pause-btn:hover {
    background-color: #bbaed8;
}

.waveform-container {
    display: flex;
    align-items: center;
    gap: 2px;
    width: 100%;
    height: 50px;
    cursor: pointer;
}

.waveform-bar {
    width: 3px;
    border-radius: 2px;
    transition: background-color 0.1s ease;
}

.bar-active {
    background-color: #3700b3; /* Active (played) color */
}

.bar-inactive {
    background-color: #cccccc; /* Inactive (unplayed) color */
}`, "",{"version":3,"sources":["webpack://./src/WaveformAudioPlayer.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gGAAgG;AACpG;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB,EAAE,yBAAyB;IACpD,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;AACzD;;AAEA;IACI,yBAAyB,EAAE,8BAA8B;AAC7D","sourcesContent":[".audio-player-container {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 400px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n\n.audio-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    margin: 0 0 15px 0;\n}\n\n.player-controls {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.play-pause-btn {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    border: 2px solid #3700b3; /* Red color from image */\n    border-radius: 50%;\n    background-color: transparent;\n    color: #3700b3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: 0;\n    /* Nudge the play icon to be visually centered */\n    padding-left: 3px;\n}\n\n.play-pause-btn:hover {\n    background-color: #bbaed8;\n}\n\n.waveform-container {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    width: 100%;\n    height: 50px;\n    cursor: pointer;\n}\n\n.waveform-bar {\n    width: 3px;\n    border-radius: 2px;\n    transition: background-color 0.1s ease;\n}\n\n.bar-active {\n    background-color: #3700b3; /* Active (played) color */\n}\n\n.bar-inactive {\n    background-color: #cccccc; /* Inactive (unplayed) color */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
